export const configuration = {
  title: 'Configuration templates',
  add: 'Add new configuration template',
  noResults: 'No data',
  newTitle: 'Create a new product configuration template',
  chooseType: 'Select product type',
  chooseSubtype: 'Select product subtype',
  confirmConfiguration: 'Confirm starting product configuration template for',
  productType: 'Product type',
  productSubtype: 'Product subtype',
  newConfigurationName: 'New configuration template name',
  productBrand: 'Product brand',
  productModel: 'Product model',
  newNamePlaceholder: 'AE 86',
  configurationCreated: 'Configuration template has been created',
  configurationCreatedPara:
    'Would you like to go to the configuration template editing screen?',
  chooseBrand: 'Select vehicle brand',
  skipBrandChoice: 'Skip brand selection',
  skipBrandModelChoice: 'Skip model selection',
  skipSubtypeChoice: 'Skip subtype selection',
  chooseBrandModel: 'Select vehicle brand model',
  isDimmensionMode: 'Dimensions from model mode',
  modelFactorConversion: 'Model unit conversion',
  dimensionModeEnabledInfo:
    'Enabled: lengths are read default value, and the model unit conversion field is not editable.',
  dimensionModeDisabledInfo:
    'Disabled: you can manually set model unit conversion, which affects scene length and calculations.',
  dimensionModeEditInfo:
    'Scene length unit and conversion can be changed only for draft configuration with EDIT permission.',
  filters: {
    all: 'All',
    productTypes: 'Type',
    productSubTypes: 'Subtype',
    brands: 'Brand',
    brandModels: 'Model',
    name: 'Search',
    status: 'Status',
    createdBy: 'Author',
  },
  errorCreatedConfiguration: 'Configuration template was not created!',
}
